import { AppRouteProps } from "@mzara/component";
import React from "react";
import { PlanningListContainer } from "./container/PlanningListContainer";
import { ProjectAppointmentCreateRoutes } from "views/create/ProjectAppointmentCreateEventRoutes";
import { ProjectCalendarCardDetailsRoutes } from "views/calendar/views/details/ProjectCalendarCardDetailsRoutes";
import { Outlet } from "react-router-dom";


export const CalendarPlanningListRoutes: Array<AppRouteProps> = [
    {
        path: "",
        title: "Harea.Vacation.Planning.Edit",
        element: (
            <PlanningListContainer />
        ),
        children: [
            ...ProjectAppointmentCreateRoutes,
            {
                path: "edit",
                element: <Outlet />,
                children: [
                    ...ProjectCalendarCardDetailsRoutes,
                ]
            },
        ]
    },
];
